__turbopack_context__.v({
  "allowance": "SoundEffects-module__bK6N8W__allowance",
  "createIntro": "SoundEffects-module__bK6N8W__createIntro",
  "createSection": "SoundEffects-module__bK6N8W__createSection",
  "deckFooter": "SoundEffects-module__bK6N8W__deckFooter",
  "deckHeader": "SoundEffects-module__bK6N8W__deckHeader",
  "deckTitle": "SoundEffects-module__bK6N8W__deckTitle",
  "demoList": "SoundEffects-module__bK6N8W__demoList",
  "demoRow": "SoundEffects-module__bK6N8W__demoRow",
  "eyebrow": "SoundEffects-module__bK6N8W__eyebrow",
  "faqSection": "SoundEffects-module__bK6N8W__faqSection",
  "faqs": "SoundEffects-module__bK6N8W__faqs",
  "featureStrip": "SoundEffects-module__bK6N8W__featureStrip",
  "finalCta": "SoundEffects-module__bK6N8W__finalCta",
  "formLabel": "SoundEffects-module__bK6N8W__formLabel",
  "formTopline": "SoundEffects-module__bK6N8W__formTopline",
  "generateFooter": "SoundEffects-module__bK6N8W__generateFooter",
  "generationStatus": "SoundEffects-module__bK6N8W__generationStatus",
  "generator": "SoundEffects-module__bK6N8W__generator",
  "hero": "SoundEffects-module__bK6N8W__hero",
  "heroActions": "SoundEffects-module__bK6N8W__heroActions",
  "heroDeck": "SoundEffects-module__bK6N8W__heroDeck",
  "heroDescription": "SoundEffects-module__bK6N8W__heroDescription",
  "heroEyebrow": "SoundEffects-module__bK6N8W__heroEyebrow",
  "heroNote": "SoundEffects-module__bK6N8W__heroNote",
  "kicker": "SoundEffects-module__bK6N8W__kicker",
  "landing": "SoundEffects-module__bK6N8W__landing",
  "landingForm": "SoundEffects-module__bK6N8W__landingForm",
  "listeningRoom": "SoundEffects-module__bK6N8W__listeningRoom",
  "liveBadge": "SoundEffects-module__bK6N8W__liveBadge",
  "mainPlay": "SoundEffects-module__bK6N8W__mainPlay",
  "modelPill": "SoundEffects-module__bK6N8W__modelPill",
  "playerStatus": "SoundEffects-module__bK6N8W__playerStatus",
  "primaryLink": "SoundEffects-module__bK6N8W__primaryLink",
  "promptChips": "SoundEffects-module__bK6N8W__promptChips",
  "promptMeta": "SoundEffects-module__bK6N8W__promptMeta",
  "related": "SoundEffects-module__bK6N8W__related",
  "rowPlay": "SoundEffects-module__bK6N8W__rowPlay",
  "samplePrompt": "SoundEffects-module__bK6N8W__samplePrompt",
  "sceneSection": "SoundEffects-module__bK6N8W__sceneSection",
  "sectionIntro": "SoundEffects-module__bK6N8W__sectionIntro",
  "seek": "SoundEffects-module__bK6N8W__seek",
  "settings": "SoundEffects-module__bK6N8W__settings",
  "steps": "SoundEffects-module__bK6N8W__steps",
  "studio": "SoundEffects-module__bK6N8W__studio",
  "studioExamples": "SoundEffects-module__bK6N8W__studioExamples",
  "studioHeader": "SoundEffects-module__bK6N8W__studioHeader",
  "textLink": "SoundEffects-module__bK6N8W__textLink",
  "time": "SoundEffects-module__bK6N8W__time",
  "trackDuration": "SoundEffects-module__bK6N8W__trackDuration",
  "trackName": "SoundEffects-module__bK6N8W__trackName",
  "trackNumber": "SoundEffects-module__bK6N8W__trackNumber",
  "transport": "SoundEffects-module__bK6N8W__transport",
  "useCase": "SoundEffects-module__bK6N8W__useCase",
  "useCaseNumber": "SoundEffects-module__bK6N8W__useCaseNumber",
  "waveform": "SoundEffects-module__bK6N8W__waveform",
});
